import { render, staticRenderFns } from "./OleMissLab9VideoResponsesQ5.vue?vue&type=template&id=afceb9e4&scoped=true&"
import script from "./OleMissLab9VideoResponsesQ5.vue?vue&type=script&lang=js&"
export * from "./OleMissLab9VideoResponsesQ5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afceb9e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VForm,VRadio,VRadioGroup})
